import React from "react";
import { MainButtons } from "../components/common/MainButton/MainButton";

const buttonDetails = [
  {
    name: "Small",
    variant: "small",
    class: "cta-small-primary",
    mobile: {
      fontSize: "text-sm (0.875rem/14px)",
      px: "px-2 (0.5rem/8px)",
      py: "py-1 (0.25rem/4px)",
    },
    tablet: {
      fontSize: "text-sm (0.875rem/14px)",
      px: "px-2.5 (0.625rem/10px)",
      py: "py-1.5 (0.375rem/6px)",
    },
    desktop: {
      fontSize: "text-sm (0.875rem/14px)",
      px: "px-3 (0.75rem/12px)",
      py: "py-1.5 (0.375rem/6px)",
    },
  },
  {
    name: "Medium (default)",
    variant: "medium",
    class: "cta-medium-primary",
    mobile: {
      fontSize: "text-base (1rem/16px)",
      px: "px-2.5 (0.625rem/10px)",
      py: "py-1.5 (0.375rem/6px)",
    },
    tablet: {
      fontSize: "text-base (1rem/16px)",
      px: "px-3 (0.75rem/12px)",
      py: "py-2 (0.5rem/8px)",
    },
    desktop: {
      fontSize: "text-base (1rem/16px)",
      px: "px-4 (1rem/16px)",
      py: "py-2 (0.5rem/8px)",
    },
  },
  {
    name: "Large",
    variant: "large",
    class: "cta-large-primary",
    mobile: {
      fontSize: "text-lg (1.125rem/18px)",
      px: "px-3 (0.75rem/12px)",
      py: "py-2 (0.5rem/8px)",
    },
    tablet: {
      fontSize: "text-lg (1.125rem/18px)",
      px: "px-4 (1rem/16px)",
      py: "py-2.5 (0.625rem/10px)",
    },
    desktop: {
      fontSize: "text-lg (1.125rem/18px)",
      px: "px-6 (1.5rem/24px)",
      py: "py-3 (0.75rem/12px)",
    },
  },
  {
    name: "Extra Large",
    variant: "extra-large",
    class: "cta-extra-large-primary",
    mobile: {
      fontSize: "text-base (1rem/16px)",
      px: "px-4 (1rem/16px)",
      py: "py-2.5 (0.625rem/10px)",
    },
    tablet: {
      fontSize: "text-xl (1.25rem/20px)",
      px: "px-5 (1.25rem/20px)",
      py: "py-3 (0.75rem/12px)",
    },
    desktop: {
      fontSize: "text-xl (1.25rem/20px)",
      px: "px-8 (2rem/32px)",
      py: "py-4 (1rem/16px)",
    },
  },
];

const breakpoints = [
  { key: 'desktop', label: 'Desktop' },
  { key: 'tablet', label: 'Tablet' },
  { key: 'mobile', label: 'Mobile' },
];

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: 24,
  marginBottom: 40,
};
const thTdStyle = {
  border: '1px solid #e0e0e0',
  padding: '12px 8px',
  textAlign: 'left',
};
const thStyle = {
  ...thTdStyle,
  background: '#f8fafc',
  fontWeight: 600,
};

const getForceClass = (key) => {
  if (key === 'mobile') return 'force-mobile';
  if (key === 'tablet') return 'force-tablet';
  if (key === 'desktop') return 'force-desktop';
  return '';
};

const UIComponents = () => (
  <div style={{ padding: 32, paddingTop: 110 }}>
    <h1 style={{ fontSize: 28, marginBottom: 8 }}>MainButtons Size Variants</h1>
    <p style={{ color: '#555', marginBottom: 24 }}>
      Below are the available primary button sizes, their Tailwind classes, and sizing details for mobile, tablet, and desktop breakpoints. Each row visually compares all button variants for a single breakpoint.
    </p>
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 32, marginBottom: 48 }}>
      {breakpoints.map(({ key, label }) => (
        <div key={key} style={{ display: 'flex', alignItems: 'flex-end', gap: 32 }}>
          <div style={{ minWidth: 70, fontWeight: 600, color: '#555', fontSize: 16, textAlign: 'right' }}>{label}</div>
          {buttonDetails.map((btn) => (
            <div key={btn.variant + key} className={getForceClass(key)} style={{ textAlign: 'center' }}>
              <MainButtons variant={btn.variant}>{btn.name}</MainButtons>
              <div style={{ fontSize: 12, marginTop: 4, color: '#888' }}>{btn.variant}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
    {breakpoints.map(({ key, label }) => (
      <div key={key} style={{ marginBottom: 48 }}>
        <h2 style={{ fontSize: 22, marginBottom: 8 }}>{label} Sizes</h2>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Button</th>
              <th style={thStyle}>Variant Name</th>
              <th style={thStyle}>Class</th>
              <th style={thStyle}>Font Size</th>
              <th style={thStyle}>Padding X</th>
              <th style={thStyle}>Padding Y</th>
            </tr>
          </thead>
          <tbody>
            {buttonDetails.map((btn) => (
              <tr key={btn.variant + key}>
                <td style={thTdStyle} className={getForceClass(key)}>
                  <MainButtons variant={btn.variant}>{btn.name}</MainButtons>
                </td>
                <td style={thTdStyle}>{btn.variant}</td>
                <td style={thTdStyle}>{btn.class}</td>
                <td style={thTdStyle}>{btn[key].fontSize}</td>
                <td style={thTdStyle}>{btn[key].px}</td>
                <td style={thTdStyle}>{btn[key].py}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ))}
  </div>
);

export default UIComponents;
